import React, { useContext, useEffect, useState } from "react";
//import classes from "./pricingDropdowns.module.scss";
import classes from "../dashboardComponents/DashboardComponents.module.scss";
import { Col, Row, OverlayTrigger, Tooltip } from "react-bootstrap";
import HelpIcon from '@mui/icons-material/Help';
import { OrgIdContext } from "../../store/orgId_context";
import { useTranslation } from "react-i18next";
import Button from "../UI/Button";
import { Dialog, DialogActions, DialogContent, DialogTitle, Switch, LinearProgress } from "@mui/material";
import CircleIcon from '@mui/icons-material/Circle';
import { useQuery } from "@tanstack/react-query";
import { DDD, E2Data } from "../../lib/ddd/ddd";
import visa from '../../assets/visad.png';
import mastercard from '../../assets/mastercardd.png';
import diners from '../../assets/dinersclubd.png';
import maestro from '../../assets/mestrod.png';
import visaelectron from '../../assets/visaelectrond.png';
import CurrencyTextField from '@lupus-ai/mui-currency-textfield'
import Select, { components } from 'react-select';
import AddCardIcon from '@mui/icons-material/AddCard';
import { NotificationManager} from 'react-notifications';

const apiRequestAddress = process.env.REACT_APP_API_ENDPOINT || window.location.origin + "/json.rpc";
const ddd = new DDD(apiRequestAddress);

const CardsSelect = ({cards, onValueChange, refetch}) => {
    const {aboutOrgId, sessionInfo, setSessionInfoHandler } = useContext(OrgIdContext);
    const [options, setOptions] = useState([]);
    const [value, setValue] = useState();
    const [cardDelete, setCardDelete] = useState();
    const {t} = useTranslation();

    /* useEffect(() => {
        if(!card || !card.Response) return;
        try{
            let data = JSON.parse(card.Response);
            setFungData(data);
            const ev = data?.events?.find((e) => {return e?.resourceType === "TX" && e?.status === "AUTHORIZED"});
            setDetails(ev);
        }catch{}
    }, [card]); */

    useEffect(() => {
        if(!cards) return;
        const options = [getCreateNewCard()];
        cards.forEach((c) => {
            if(!c.Unscheduled && !c.UnscheduledActive) return null;
            try{
                let data = JSON.parse(c.Response);
                c.ResponseJS = data;
                c.CardData = data?.events?.find((e) => {return e?.resourceType === "TX" && e?.status === "AUTHORIZED"})?.details?.card;
                c.CardDetails = data?.events?.find((e) => {return e?.resourceType === "TX" && e?.status === "AUTHORIZED"})?.details;
                options.push({value: c.Id, label: c.CardData?.brand + " " + c.CardData?.last4, data: c});
            }catch{}
        });
        setOptions(options);
        if(!value) {
            if(options.length > 1){
                setValue(options[1]); onValueChange(options[1]);
            }else{
                setValue(options[0]); onValueChange(options[0]);
            }
        }
    }, [cards]);

    const getCardImage = (c) => {
        switch(c?.brand?.toLowerCase()){
            case "visa":
                return <img src={visa} alt="visa" style={{maxHeight:"35px"}}/>;
            case "mastercard":
                return <img src={mastercard} alt="visa" style={{maxHeight:"35px"}}/>;
            case "diners":
                return <img src={diners} alt="visa" style={{maxHeight:"35px"}}/>;
            case "maestro":
                return <img src={maestro} alt="visa" style={{maxHeight:"35px"}}/>;
            default:
                //return <div className="fw-bold fs-5">{c?.brand}</div>;
                return <AddCardIcon className ="me-2"/>;
        }
    }

    const getCreateNewCard = () =>{
        return{
            value: -1,
            Id: -1,
            label: t("Add New Card"),
            CardData: {
                cardholderName: "Add New Card",
            }
        }
    }

    const onCardDeleteClick = (card) => {
        setCardDelete(card);
    }

    const SingleValue = ({ children, ...props }) => {
        const card = props.data.value === -1 ? getCreateNewCard() : getCardById(props.data.value);
        return <components.SingleValue {...props}>
            <div className="d-flex" style={{ padding: ".5rem",overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', color:"var(--main-blue)" }}>
                <div className="align-content-center">
                    <span style={{marginRight:"0.5rem"}}>{getCardImage(card?.CardData, "30px")}</span>
                </div>
                <div>
                    <div>{card?.CardData?.cardholderName}</div>
                    {card?.CardData?.expiryMonth && <div className="fs-7">{t("Expires")}: {card?.CardData?.expiryMonth}/{card?.CardData?.expiryYear}</div>}
                </div>
                {card?.CardData?.lastFour && <div className="ms-auto align-items-center align-content-center">
                    <div>&#9679;&#9679;&#9679;&#9679;{card?.CardData?.lastFour}</div>
                </div>}
            </div>
        </components.SingleValue>
    };

    const Option = props => {
        const card = props.data.value === -1 ? getCreateNewCard() : getCardById(props.data.value);
        return <components.Option {...props}>
            <div className="d-flex" style={{ padding: ".5rem",overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', color:"var(--main-blue)", position: "relative"}}>
                {card?.CardData?.lastFour && <div style={{position:"absolute", top:"2px", right : "5px"}}>
                    <OverlayTrigger
                        placement="top"
                        style={{zIndex: 9999}}
                        overlay={
                            <Tooltip id={`tooltip-top`} style={{zIndex: 9999}}>
                                {t("Forget this payment method")}
                            </Tooltip>
                        }
                    >
                        <div className={`fs-8 ${classes.cardForger}`} onClick={(e) => {e.stopPropagation(); onCardDeleteClick(card);}}>{t("Delete")}</div>
                    </OverlayTrigger>
                </div>}
                <div className="align-content-center">
                    <span style={{marginRight:"0.5rem"}}>{getCardImage(card?.CardData, "30px")}</span>
                </div>
                <div>
                    <div>{card?.CardData?.cardholderName}</div>
                    {card?.CardData?.expiryMonth && <div className="fs-7">{t("Expires")}: {card?.CardData?.expiryMonth}/{card?.CardData?.expiryYear}</div>}
                </div>
                {card?.CardData?.lastFour && 
                <div className="ms-auto align-items-center align-content-center">
                    <div className="mt-4">&#9679;&#9679;&#9679;&#9679;{card?.CardData?.lastFour}</div>
                </div>}
            </div>
        </components.Option>
    };

    const getCardById = (id) => {
        return cards.find((c) => c.Id === id);
    }

    const deleteCard = (card) => {
        if(!card) return NotificationManager.error(t("An error occured. Please contact support."), t("Error"), 5000);
        setCardDelete(null);
        const e2data = new E2Data("EU_FungCheckout");
        e2data.filter = `Id='${card.Id}'`;
        e2data.values = {"UnscheduledActive": false};
        e2data.Modify().then(res => {
            refetch();
        });
    }

    return (<>
    <Dialog
        sx={{ '& .MuiDialog-paper': { width: '80%', maxHeight: 435 } }}
        maxWidth="xs"
        TransitionProps={{ }}
        open={cardDelete}>
            <DialogTitle>{t("Confirm card removal")}</DialogTitle>
            <DialogContent dividers>
            <div>{t("Are you certain you want to remove this card?")}</div>
            <div className="d-flex align-items-end mt-2">
                {getCardImage(cardDelete?.CardData, "30px")}
                <div className="ms-2">{cardDelete?.CardData?.cardholderName} ({cardDelete?.CardData?.expiryMonth}/{cardDelete?.CardData?.expiryYear})</div>
                <div className="ms-auto">&#9679;&#9679;&#9679;&#9679;{cardDelete?.CardData?.lastFour}</div>
            </div>
            </DialogContent>
            <DialogActions>
                <Button className="ps-2 pe-2" autoFocus onClick={() => setCardDelete(null)}>
                {t("Cancel")}
                </Button>
                <Button className="ps-2 pe-2" onClick={() => {deleteCard({...cardDelete})}}>Ok</Button>
            </DialogActions>
        </Dialog>
        <Select 
            options={options}
            components={{ SingleValue, Option}}
            onChange={(e) => {console.log(e); setValue(e); onValueChange(e);}}
            value={value}
            styles={{
                control: (baseStyles, state) => ({
                  ...baseStyles,
                  /* border: "1px solid #e8490e!important",
                  borderRadius: '12px',
                  outline: 'none',
                  boxShadow : 'none',
                  height:"35px",
                  marginBottom: '0.5rem', */
                }),
                valueContainer: (baseStyles) => ({
                    ...baseStyles,
                    //height: '35px',
                    padding: '0 12px',
                }),
                input: (baseStyles) => ({
                    ...baseStyles,
                    margin: 0,
                    padding: 0,
                }),
                menu: (base) => ({
                  ...base,
                  overflow: 'visible',
                  //maxHeight: '400px',
                }),
                menuList: (base) => ({
                    ...base,
                    maxHeight:"none",
                }),
                menuPortal: base => ({ ...base, zIndex: 9998, left: '50%',top: '50%',transform: 'translate(-50%, +10px)' })
              }}
              menuPortalTarget={document.body}
            />
        </>);
};

export default CardsSelect;
